export default {
  INSTALLED: "installed",
  NEW_CUSTODY: "new_custody",
          PAUSED: "paused",
};
